module.exports = __webpack_public_path__ + "/bundle/asset/U1_06-9bc22cf19aed9921aa71e5c34d9b5af4.gif";